module.exports = __webpack_public_path__ + "static/img/not-start-2-2x.571f058.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/competition/not-start-2-2x.png
// module id = HP9V
// module chunks = 86